import React from 'react';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';

const ActiveRadioGroup = ({ value, onChange}) => {
  return (
    <FormControl component="fieldset">
      <RadioGroup
        row
        value={value}
        onChange={onChange}
        name="status"
      >
        <FormControlLabel value="active" control={<Radio />} label="Active" />
        <FormControlLabel value="inactive" control={<Radio />} label="Inactive" />
      </RadioGroup>
    </FormControl>
  );
};

export default ActiveRadioGroup;